
import { Component, Vue } from 'vue-property-decorator';
import { BrandingImageType } from 'ah-api-gateways';

@Component
export default class AppLogo extends Vue {
  get thumbnailLogoLink() {
    let out = this.$theme.val?.logos.find((l) => l.type === BrandingImageType.THUMBNAIL)?.link;
    return out;
  }
}
